import { render } from "./PricingComp.vue?vue&type=template&id=3f460adf"
import script from "./PricingComp.vue?vue&type=script&lang=js"
export * from "./PricingComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__